module.exports = __webpack_public_path__ + "img/15.ab67bc12.jpg";